import { useCallback } from "react";

export function useOpenInBrowser() {
 
  const isInAppBrowser = useCallback(() => {
    const ua = navigator.userAgent || navigator.vendor || "";
    return /FBAN|FBAV|FB_IAB|Instagram|Line|Snapchat|Twitter|TikTok/i.test(ua);
  }, []);

  const isAndroidWebview = useCallback(() => {
    const ua = navigator.userAgent || navigator.vendor || "";
    return /android.*wv|android.*webview/i.test(ua);
  }, []);

  const isAndroid = useCallback(() => /Android/i.test(navigator.userAgent), []);
  const isIOS = useCallback(() => /iPhone|iPad|iPod/i.test(navigator.userAgent), []);

  const handleNavigation = useCallback((url: string, onNormalNavigation?: () => void) => {
    if (!url.startsWith("http")) {
      return;
    }
   
    if (isInAppBrowser()) 
    {
      if (isAndroid()) 
      {
        const intentUrl = `intent://${url.replace(/^https?:\/\//, "")}#Intent;package=com.android.chrome;scheme=https;end`;
        window.location.href = intentUrl;

        setTimeout(() => {
          window.open(url, "_blank", "noopener,noreferrer");
        }, 800);
      } 
      else
      {
        window.open(url, "_blank", "noopener,noreferrer");
      }
    }
    else 
    {
      if (onNormalNavigation) 
      {
        onNormalNavigation();
      } 
      else 
      {
        window.location.href = url;
      }
    }
  }, [isInAppBrowser, isAndroid, isIOS, isAndroidWebview]);

  return handleNavigation;
}
